<template>
    <transition name="trans_bot_modal">
        <left-top v-if="layerType=='leftTop'"></left-top>
        <left-mid v-if="layerType=='leftMid'"></left-mid>
        <left-bot v-if="layerType=='leftBot'"></left-bot>
        <right-top v-if="layerType=='rightTop'"></right-top>
        <right-mid v-if="layerType=='rightMid'"></right-mid>
        <right-bot v-if="layerType=='rightBot'"></right-bot>
        <mid-top v-if="layerType=='midTop0'"></mid-top>
        <mid-top-right v-if="layerType=='midTop1' || layerType=='midTop2' || layerType=='midTop3'"></mid-top-right>
        <mid-bot v-if="layerType=='midBot'"></mid-bot>
    </transition>
</template>
<script>
import leftTop from './leftTop.vue';
import leftMid from './leftMid.vue';
import leftBot from './leftBot.vue';
import rightTop from './rightTop.vue';
import rightMid from './rightMid.vue';
import rightBot from './rightBot.vue';
import midTop from './midTop.vue';
import midTopRight from './midTopRight.vue';
import midBot from './midBot.vue';
export default {
  name:"",    
  data: () => ({
    
  }),
  watch: {
    layerType: {
        handler(newVal, oldVal){
            console.log(newVal);
            console.log('弹窗类型');
            
        },
        immediate: true,
        deep: true,
    }
  },
  components: {
    leftTop,
    leftMid,
    leftBot,
    rightTop,
    rightMid,
    rightBot,
    midTop,
    midTopRight,
    midBot
  },
  created() {

  },
  mounted() {

  },
  computed: {
    layerType(){
        return this.$store.state.showLayer.type;
    }
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/layer/layer-tem.vue